module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_02@2x-d128d63b2220e3ff1172983a573cb3af.webp";